export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4732.2b10e9e8.jpg";